import { render, staticRenderFns } from "./activity-form-preview-columns.vue?vue&type=template&id=0607f4c4&scoped=true&"
import script from "./activity-form-preview-columns.vue?vue&type=script&lang=js&"
export * from "./activity-form-preview-columns.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-preview-columns.vue?vue&type=style&index=0&id=0607f4c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0607f4c4",
  null
  
)

component.options.__file = "activity-form-preview-columns.vue"
export default component.exports